/**
 * Синглтон-модуль для связывания хуков, например, чтобы отправить
 * разом все текущие связанные хуки в одном запросе на сервер для
 * одновременной перерисовки
 */

/**
 * Хранилище массива связанных хуков в мапе мап:
 * первый ключ - refId,
 * второй ключ - имя коллекции хуков
 *
 * @type {{[]}}
 */
const store: Record<string, Record<string, string[]>> = {};

/**
 * Зарегистрированные имена коллекций для массивов связанных хуков
 * Можно использовать собственные имена, но придется самостоятельно
 * отслеживать уникальность.
 */
export const collections = {
    REACTION_COMPONENTS: 'widgets',
    ICON_REACTIONS: 'icons'
};

export function add(ref: string, collectionName: string, hookId: string) {
    let collections = store[ref] || {};
    let collection = collections[collectionName] || [];

    if (collection.indexOf(hookId) === -1) {
        collection.push(hookId);
        collections[collectionName] = collection;
        store[ref] = collections;
    }
}

export function remove(ref: string, collectionName: string, hookId: string) {
    if (!store[ref]) {
        return;
    }

    let collections = store[ref];

    if (!collections[collectionName]) {
        return;
    }

    let collection = collections[collectionName];
    let index = collection.indexOf(hookId);

    if (index !== -1) {
        collection.splice(index, 1);
    }
}

export function get(ref: string) {
    return store[ref];
}

// Экспорты выше - для совместимости со старым кодом.
export const LinkedHooksStore = {
    collections: collections,
    add: add,
    remove: remove,
    get: get
}